import * as React from 'react';
import { SVGProps } from 'react';

const SvgDiagnosis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7803_2542)">
      <path
        fill="currentColor"
        d="M12.717 12.831c.54 0 .978-.437.978-.981a.979.979 0 1 0-1.955 0c0 .544.438.981.977.981Zm0 3.919c.54 0 .978-.438.978-.981a.979.979 0 1 0-1.955 0c0 .543.438.981.977.981Zm0 3.919c.54 0 .978-.438.978-.982a.979.979 0 1 0-1.955 0c0 .544.438.982.977.982Zm0 3.912c.54 0 .978-.437.978-.981a.979.979 0 1 0-1.955 0c0 .544.438.981.977.981Zm0 3.919c.54 0 .978-.438.978-.981a.979.979 0 1 0-1.955 0c0 .544.438.981.977.981Z"
      />
      <path
        fill="currentColor"
        d="M31.727 18.706c0-2.431-1.289-4.562-3.22-5.762V8.43c0-1.056-.888-1.918-1.98-1.918h-5.403v-.657H18.94V5h-2.635v.862h-2.203v.657H9.98C8.889 6.519 8 7.38 8 8.437v22.026h1.905V8.436s.025-.043.076-.043h4.114v.631c0 .194.159.35.35.35h6.317a.35.35 0 0 0 .35-.35v-.631h5.402c.057 0 .076.031.076.043v3.7a6.68 6.68 0 0 0-1.67-.218c-3.745 0-6.8 3.043-6.8 6.787 0 3.744 3.048 6.788 6.8 6.788a6.68 6.68 0 0 0 1.67-.219v5.175h1.905v-5.988a6.781 6.781 0 0 0 3.22-5.762l.012.006Zm-11.689 0c0-2.712 2.197-4.912 4.895-4.912 2.699 0 4.896 2.206 4.896 4.912 0 2.707-2.197 4.913-4.896 4.913-2.698 0-4.895-2.206-4.895-4.913Z"
      />
      <path
        fill="currentColor"
        d="m26.826 15.919-2.8 2.8-.985-.988-1.403 1.4 2.368 2.375 4.197-4.2-1.384-1.381.007-.006Z"
      />
      <path
        fill={props.fill}
        d="M28.502 30.456v3.9L12 34.375l-4.006-3.919h20.508Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_7803_2542">
        <path
          fill="#fff"
          d="M0 0h24.127v29.375H0z"
          transform="translate(7.62 5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDiagnosis;
